export function mergeDefaultOptions(options = {}) {
    const prefix = options.hasOwnProperty('prefix') ? options.prefix : '';
    const dataType = options.hasOwnProperty('dataType') ? options.dataType : 'json';

    return {
        prefix,
        dataType,
        headers: options.headers
    }
}


// WEBPACK FOOTER //
// ./src/services/api/utils/providerOptions.js